module.exports = __webpack_public_path__ + "media/kanxi.b49bd3f0.mp4";